import { ArrowRight } from "lucide-react"
import { Link } from "@inertiajs/react"
import { Button } from "@/components/ui/button"
import { MarketingLayout } from "@/components/marketing/MarketingLayout"
import { MarketingMetadata } from "@/components/marketing/MarketingMetadata"
import type { MarketingPageProps } from "@/types/marketing"

export default function MarketingPage(props: MarketingPageProps) {
  return (
    <>
      <MarketingMetadata
        alternateUrls={props.alternate_urls}
        canonicalUrl={props.canonical_url}
        description={props.description}
        locale={props.locale}
        noindex={props.noindex}
        socialImageUrl={props.social_image_url}
        title={props.title}
      />
      <MarketingLayout
        currentPageKey={props.page_key}
        footer={props.footer}
        homeHref={props.home_href}
        languageSwitch={props.language_switch}
        locale={props.locale}
        navigation={props.navigation}
        consultationHref={props.consultation_href}
      >
        <section className="marketing-page-shell">
          <div className="marketing-page-copy">
            <h1 className="type-marketing-display">{props.heading}</h1>
            <p className="marketing-page-summary type-marketing-body">
              {props.summary}
            </p>
            <div className="marketing-page-actions">
              {props.page_key !== "website_review" && (
                <Button asChild variant="marketing" size="marketingLg">
                  <Link href={props.consultation_href} data-analytics-id="page-consultation">
                    {props.locale === "hr" ? "Zatražite besplatne 30-minutne konzultacije" : "Request a free 30-minute consultation"}
                    <ArrowRight className="marketing-inline-icon" aria-hidden="true" />
                  </Link>
                </Button>
              )}
              <Link className="marketing-text-link type-marketing-action" href={props.work_href}>
                {props.locale === "hr" ? "Pogledajte radove" : "See the work"}
              </Link>
            </div>
          </div>
          <aside className="marketing-page-note" aria-label={props.locale === "hr" ? "Način rada" : "How Zmile works"}>
            <span className="marketing-page-note-index" aria-hidden="true">01</span>
            <p>
              {props.locale === "hr"
                ? "Jasan problem. Najjednostavnije korisno rješenje. Izravna odgovornost za isporuku."
                : "A clear problem. The simplest useful solution. Direct accountability for delivery."}
            </p>
          </aside>
        </section>
      </MarketingLayout>
    </>
  )
}
